import Star from "@/assets/icons/star.svg";
import React from "react";

export const MultiDietReviewsStars = () => {
  return (
    <div className="flex items-center gap-1">
      {Array.from({ length: 5 }, (_, index) => {
        return <Star key={index} className="w-4 h-4" />;
      })}
    </div>
  );
};
